module.exports = __webpack_public_path__ + "img/new-badge-failed.12c25925.svg";